import React, { Component } from 'react';

import SubActions from '.';
import SubActionButton from './SubActionButton';
import ExpireQuickSubModal from 'components/modals/ExpireSubModal/quick';
import UpdateQuickDeviceModal from 'components/modals/UpdateDeviceModal/quick';
import { getSubStatus } from 'helpers/subs';
import SuspendQuickSubModal from 'components/modals/SuspendSubModal/quick';
import RestoreQuickSubModal from 'components/modals/RestoreSubModal/quick';
import ReactivateQuickModal from 'components/modals/ReactivateModal/quick';
import SetQuickUpcomingPlanModal from 'components/modals/SetUpcomingPlanModal/quick';
import SetQuickPlanModal from 'components/modals/SetPlanModal/quick';
import UpgradeQuickPlanModal from 'components/modals/UpgradePlanModal/quick';
import QuickUsageModal from 'components/modals/QuickUsageModal';
import ChangeVoicemailPinModal from 'components/modals/ChangeVoicemailPinModal';
import DeleteVoicemailPinModal from 'components/modals/DeleteVoicemailPinModal/quick';
import QuickChangeCallerIdModal from 'components/modals/ChangeCallerIdModal/quick';
import QuickChangeMdnModal from 'components/modals/ChangeMdnModal/quick';
import QuickActivateModal from 'components/modals/ActivateModal/quick';
import QuickSetSubAddressModal from 'components/modals/QuickSetSubAddressModal';
import QuickUpdateStatusModal from 'components/modals/UpdateStatusModal/quick';
import QuickUpdateSeviceCodesModal from 'components/modals/UpdateServiceCodesModal/quick';
import { can, permActions } from 'permissions';

const {
  SET_QUICK_UPCOMING_PLAN,
  SET_QUICK_PLAN,
  UPGRADE_QUICK_INVOICE,
  EXPIRE_QUICK_SUB,
  UPDATE_QUICK_DEVICE,
  SUSPEND_QUICK_SUB,
  RESTORE_QUICK_SUB,
  GET_QUICK_USAGE,
  CHANGE_QUICK_VOICEMAIL_PIN,
  DELETE_QUICK_VOICEMAIL_PIN,
  CHANGE_QUICK_CALLER_ID,
  CHANGE_QUICK_MDN,
  ACTIVATE_QUICK_SUB,
  SET_QUICK_SERVICE_ADDRESS,
  UPDATE_QUICK_STATUS,
  UPDATE_QUICK_SERVICE_CODES,
  REACTIVATE_QUICK_SUB,
} = permActions;

class QuickSubActions extends Component {
  state = {
    opennedModal: '',
  };

  setOpennedModal = (modal) => this.setState({ opennedModal: modal });
  closeModal = () => this.setState({ opennedModal: '' });

  render() {
    const { sub, user, loggedInUser } = this.props;
    const { opennedModal } = this.state;

    const subStatus = getSubStatus(sub);
    const isExpired = subStatus === 'expired';
    const isNew = subStatus === 'new';
    const isPending = subStatus === 'pending';
    const isSuspended = subStatus === 'suspended';
    const isActive = subStatus === 'active';

    const showUpdateDevice =
      (isNew || isActive) && can(loggedInUser, UPDATE_QUICK_DEVICE);
    const showSetPlan =
      (isNew || isActive) && can(loggedInUser, SET_QUICK_PLAN);
    const showSetUpcomingPlan =
      isActive && can(loggedInUser, SET_QUICK_UPCOMING_PLAN);
    const showUpgradeInvoice =
      isActive && can(loggedInUser, UPGRADE_QUICK_INVOICE);
    const showUsage =
      (isExpired || isSuspended || isActive) &&
      can(loggedInUser, GET_QUICK_USAGE);
    const showSuspend = isActive && can(loggedInUser, SUSPEND_QUICK_SUB);
    const showRestore = isSuspended && can(loggedInUser, RESTORE_QUICK_SUB);
    const showExpire =
      (isActive || isSuspended) && can(loggedInUser, EXPIRE_QUICK_SUB);
    const showChangeVoicemailPin =
      isActive && can(loggedInUser, CHANGE_QUICK_VOICEMAIL_PIN) && false; // not supported by quick api yet
    const showDeleteVoicemailPin =
      isActive && can(loggedInUser, DELETE_QUICK_VOICEMAIL_PIN);
    const showChangeCallerId =
      isActive && can(loggedInUser, CHANGE_QUICK_CALLER_ID);
    const showChangeMdn = isActive && can(loggedInUser, CHANGE_QUICK_MDN);
    const showActivate =
      !isPending &&
      !isExpired &&
      !isActive &&
      !isSuspended &&
      can(loggedInUser, ACTIVATE_QUICK_SUB);
    const showSetServiceAddress =
      isActive && can(loggedInUser, ACTIVATE_QUICK_SUB);
    const showUpdateServiceCodes =
      (isActive || isSuspended) &&
      can(loggedInUser, UPDATE_QUICK_SERVICE_CODES);
    const showUpdateStatus = can(loggedInUser, UPDATE_QUICK_STATUS);
    const showReactivation =
      isExpired && can(loggedInUser, REACTIVATE_QUICK_SUB);

    const buttons = [
      {
        id: UPDATE_QUICK_DEVICE,
        iconPath: '/images/icons/subActions/device-icon.svg',
        text: 'Update Device',
        onClick: this.setOpennedModal,
        isShown: showUpdateDevice,
      },
      {
        id: SUSPEND_QUICK_SUB,
        iconPath: '/images/icons/subActions/pause-icon.svg',
        text: 'Suspend Sub',
        onClick: this.setOpennedModal,
        isShown: showSuspend,
      },
      {
        id: RESTORE_QUICK_SUB,
        iconPath: '/images/icons/subActions/play-icon.svg',
        text: 'Restore Sub',
        onClick: this.setOpennedModal,
        isShown: showRestore,
      },
      {
        id: REACTIVATE_QUICK_SUB,
        iconPath: '/images/icons/subActions/play-icon.svg',
        text: 'Reactivate Sub',
        onClick: this.setOpennedModal,
        isShown: showReactivation,
      },
      {
        id: EXPIRE_QUICK_SUB,
        iconPath: '/images/icons/subActions/cross-icon.svg',
        text: 'Expire Sub',
        onClick: this.setOpennedModal,
        isShown: showExpire,
      },
      {
        id: ACTIVATE_QUICK_SUB,
        iconPath: '/images/icons/subActions/user-icon.svg',
        text: 'Activate Sub',
        onClick: this.setOpennedModal,
        isShown: showActivate,
      },
      {
        id: SET_QUICK_PLAN,
        iconPath: '',
        text: 'Update Plan',
        onClick: this.setOpennedModal,
        isShown: showSetPlan,
      },
      {
        id: UPGRADE_QUICK_INVOICE,
        iconPath: '',
        text: 'Plan Upgrade',
        onClick: this.setOpennedModal,
        isShown: showUpgradeInvoice,
      },
      {
        id: GET_QUICK_USAGE,
        iconPath: '',
        text: 'Usage Details',
        onClick: this.setOpennedModal,
        isShown: showUsage,
      },
      {
        id: SET_QUICK_UPCOMING_PLAN,
        iconPath: '',
        text: 'Upcoming Plan',
        onClick: this.setOpennedModal,
        isShown: showSetUpcomingPlan,
      },
      {
        id: SET_QUICK_SERVICE_ADDRESS,
        iconPath: '',
        text: 'Update Service Address',
        onClick: this.setOpennedModal,
        isShown: showSetServiceAddress,
        smallerText: true,
      },
      {
        id: UPDATE_QUICK_SERVICE_CODES,
        iconPath: '',
        text: 'Modify Service Codes',
        onClick: this.setOpennedModal,
        isShown: showUpdateServiceCodes,
        smallerText: true,
      },
      {
        id: CHANGE_QUICK_VOICEMAIL_PIN,
        iconPath: '',
        text: 'Change Voicemail PIN',
        onClick: this.setOpennedModal,
        isShown: showChangeVoicemailPin,
        smallerText: true,
      },
      {
        id: CHANGE_QUICK_MDN,
        iconPath: '',
        text: 'Change MDN',
        onClick: this.setOpennedModal,
        isShown: showChangeMdn,
      },
      {
        id: DELETE_QUICK_VOICEMAIL_PIN,
        iconPath: '',
        text: 'Delete Voicemail PIN',
        onClick: this.setOpennedModal,
        isShown: showDeleteVoicemailPin,
        smallerText: true,
      },
      {
        id: CHANGE_QUICK_CALLER_ID,
        iconPath: '',
        text: 'Change Caller Id',
        onClick: this.setOpennedModal,
        isShown: showChangeCallerId,
      },
      {
        id: UPDATE_QUICK_STATUS,
        iconPath: '',
        text: 'Update Status',
        onClick: this.setOpennedModal,
        isShown: showUpdateStatus,
      },
    ];

    return (
      <SubActions>
        {buttons.map((button) => (
          <SubActionButton key={button.id} {...button} />
        ))}
        <UpdateQuickDeviceModal
          sub={sub}
          isOpen={opennedModal === UPDATE_QUICK_DEVICE}
          closeModal={this.closeModal}
        />
        <SuspendQuickSubModal
          sub={sub}
          isOpen={opennedModal === SUSPEND_QUICK_SUB}
          user={user}
          closeModal={this.closeModal}
        />
        <RestoreQuickSubModal
          sub={sub}
          isOpen={opennedModal === RESTORE_QUICK_SUB}
          closeModal={this.closeModal}
        />
        <ReactivateQuickModal
          sub={sub}
          isOpen={opennedModal === REACTIVATE_QUICK_SUB}
          closeModal={this.closeModal}
        />
        <ExpireQuickSubModal
          sub={sub}
          isOpen={opennedModal === EXPIRE_QUICK_SUB}
          closeModal={this.closeModal}
        />
        <SetQuickPlanModal
          sub={sub}
          subId={sub?.id}
          user={user}
          isOpen={opennedModal === SET_QUICK_PLAN}
          closeModal={this.closeModal}
        />
        <UpgradeQuickPlanModal
          sub={sub}
          subId={sub?.id}
          user={user}
          isOpen={opennedModal === UPGRADE_QUICK_INVOICE}
          closeModal={this.closeModal}
        />
        <QuickUsageModal
          sub={sub}
          isOpen={opennedModal === GET_QUICK_USAGE}
          closeModal={this.closeModal}
        />
        <SetQuickUpcomingPlanModal
          sub={sub}
          subId={sub?.id}
          user={user}
          isOpen={opennedModal === SET_QUICK_UPCOMING_PLAN}
          closeModal={this.closeModal}
        />
        <ChangeVoicemailPinModal
          sub={sub}
          isOpen={opennedModal === CHANGE_QUICK_VOICEMAIL_PIN}
          closeModal={this.closeModal}
        />
        <DeleteVoicemailPinModal
          sub={sub}
          isOpen={opennedModal === DELETE_QUICK_VOICEMAIL_PIN}
          closeModal={this.closeModal}
        />
        <QuickChangeCallerIdModal
          sub={sub}
          isOpen={opennedModal === CHANGE_QUICK_CALLER_ID}
          closeModal={this.closeModal}
        />
        <QuickChangeMdnModal
          subId={sub?.id}
          userId={user?.id}
          isOpen={opennedModal === CHANGE_QUICK_MDN}
          closeModal={this.closeModal}
        />
        <QuickActivateModal
          sub={sub}
          isOpen={opennedModal === ACTIVATE_QUICK_SUB}
          subId={sub?.id}
          user={user}
          closeModal={this.closeModal}
        />
        <QuickSetSubAddressModal
          sub={sub}
          isOpen={opennedModal === SET_QUICK_SERVICE_ADDRESS}
          closeModal={this.closeModal}
        />
        <QuickUpdateStatusModal
          sub={sub}
          isOpen={opennedModal === UPDATE_QUICK_STATUS}
          closeModal={this.closeModal}
        />
        <QuickUpdateSeviceCodesModal
          sub={sub}
          isOpen={opennedModal === UPDATE_QUICK_SERVICE_CODES}
          closeModal={this.closeModal}
        />
      </SubActions>
    );
  }
}

export default QuickSubActions;
